(function () {
    'use strict';
    var controllerId = 'studenteSessionAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'sectionMenu', 'sessionId', 'classi', 'classeId', studenteSessionAdd]);

    function studenteSessionAdd($scope, $uibModalInstance, datacontext, sectionMenu, sessionId, classi, classeId) {
    		$scope.studenteSession = {};
        $scope.classi = classi;

        


        //Parametro classeId utilizzato per impostare e bloccare selezione Materia
        //Utilizzato in caso di creazione unovo question da view /app/test/testDetail.html
        if (classeId) {
            $scope.classeId = classeId;
            $scope.studenteSession.classeId = classeId;
            getListAllievi();
        }

        if(sessionId)
        {
        	$scope.studenteSession.sessionId = sessionId;
        }

        

        $scope.ok = function (isValid) {
        	if (isValid) {
        		var studentiList = [];
        		$("input:checkbox[name=studenteId]:checked").each(function () {
        			studentiList.push($(this).val());
        		});

        		var result = addItem($scope.studenteSession.sessionId, studentiList)
            $uibModalInstance.close(result);
          }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getListAllievi() {
        	return datacontext.studente_getAllByClasse($scope.studenteSession.classeId).then(function (data) {
        		return $scope.studenti = data;
        	});
        }
        
        function addItem(sessionId, studentiList) {
        	return datacontext.studenteSession_addList(sessionId, studentiList).then(function (data) {
                if (!data) return null;

                return data;
            });
        }

    }
})();